export default {
      id: "oc-res-ssh-agent-usage",
      viewBox: "0 0 1025 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-ssh-agent",
      toString: function () {
        return this.url;
      }
    }